import React, { useEffect } from 'react';
import Logo from './Logo';

interface OnboardingReturnPageProps {
    type: 'complete' | 'refresh';
}

const OnboardingReturnPage: React.FC<OnboardingReturnPageProps> = ({ type }) => {
    const deepLink = type === 'complete'
        ? 'clero://wallet?success=true'
        : 'clero://wallet?refresh=true';

    useEffect(() => {
        window.location.href = deepLink;
    }, [deepLink]);

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 space-y-8">
            <div className="text-center space-y-4 max-w-md">
                <div className="mx-auto w-16 h-16 rounded-3xl bg-teal-50 text-teal-600 flex items-center justify-center">
                    <i className="fas fa-mobile-screen-button text-2xl"></i>
                </div>

                <h1 className="text-2xl font-black tracking-tight text-gray-900">
                    {type === 'complete' ? 'Setup Complete' : 'Resume Setup'}
                </h1>
                <p className="text-sm text-gray-500 font-medium leading-relaxed">
                    We are sending you back to the Clero app now.
                </p>

                <button
                    onClick={() => {
                        window.location.href = deepLink;
                    }}
                    className="w-full bg-black text-white py-4 px-6 rounded-2xl font-bold text-sm tracking-wide hover:bg-gray-800 transition-all"
                >
                    Open Clero App
                </button>
            </div>

            <Logo size="sm" className="opacity-30" />
        </div>
    );
};

export default OnboardingReturnPage;
